var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.709,
    height: 62.234,
    viewBox: "0 0 81.709 62.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-help",
    transform: "translate(-1.626 -13.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(2.126 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M41.634,30.8H19.1a2.3,2.3,0,1,0,0,4.593H41.634a2.3,2.3,0,0,0,0-4.593Z",
    transform: "translate(-4.638 -16.512)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M19.1,51.893h18.54a2.3,2.3,0,0,0,0-4.593H19.1a2.3,2.3,0,1,0,0,4.593Z",
    transform: "translate(-4.638 -18.979)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M41.634,63.7H19.1a2.3,2.3,0,1,0,0,4.593H41.634a2.287,2.287,0,0,0,2.3-2.3A2.235,2.235,0,0,0,41.634,63.7Z",
    transform: "translate(-4.638 -21.432)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M63.734,25.226a20.1,20.1,0,0,0-8.164,1.786V16.3a2.287,2.287,0,0,0-2.3-2.3H4.8a2.287,2.287,0,0,0-2.3,2.3V72.937a2.287,2.287,0,0,0,2.3,2.3H53.188a2.287,2.287,0,0,0,2.3-2.3V62.562a18.8,18.8,0,0,0,8.164,1.786,19.561,19.561,0,0,0,.085-39.121ZM50.892,70.641H7.178V18.593H50.892v11.4a19.469,19.469,0,0,0,0,29.426ZM63.734,59.67A14.883,14.883,0,1,1,78.617,44.787,14.9,14.9,0,0,1,63.734,59.67Z",
    transform: "translate(-2.5 -14)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M73.449,37.6c-4.763,0-6.549,3.487-6.549,5.868v.34a1.126,1.126,0,0,0,1.106,1.106h1.956a1.126,1.126,0,0,0,1.106-1.106v-.34c0-.17.085-1.786,2.381-1.786,1.616,0,2.126.51,2.126,1.786,0,.936-1.361,2.041-2.126,2.636a5.557,5.557,0,0,0-2.381,4.337v.765a1.126,1.126,0,0,0,1.106,1.106h1.956a1.126,1.126,0,0,0,1.106-1.106v-.765c0-.34.51-.85.936-1.191,1.361-1.106,3.657-2.977,3.657-5.868C79.742,40.662,78.126,37.6,73.449,37.6Z",
    transform: "translate(-12.13 -17.529)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.466,
    cy: 2.466,
    r: 2.466,
    transform: "translate(58.597 36.485)",
    fill: "#a86b45"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.30bec3d3d865187016e1d5e229d3c7ff.svg";
export { ForwardRef as ReactComponent };